import { CSSResultGroup, TemplateResult, html } from 'lit';
import { OutlineElement } from '../../base/outline-element/outline-element';
import { customElement, property } from 'lit/decorators.js';
import componentStyles from './se-spacer.css.lit';
import { MobileController } from '../../controllers/mobile-controller';

/**
 * The SeSpacer component
 * @element se-spacer
 */
@customElement('se-spacer')
export class SeSpacer extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];
  private mobileController = new MobileController(this);

  @property({ type: String })
  desktop: string;

  @property({ type: String })
  mobile: string;

  render(): TemplateResult {
    const height = this.mobileController.isMobile
      ? `${this.mobile ? this.mobile : this.desktop}rem`
      : `${this.desktop}rem`;
    return html`<div class="se-spacer" style="height: ${height};"></div>`;
  }
}
